
import { AxiosResponse } from 'axios';
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { QData } from "../../../types/basic-type-list";
import { TResponse, TResponseWithQData } from "../../../types/common";
import { IHomepagePayload } from "../../../types/api/homepage";


export async function saveHomeData(data: IHomepagePayload): Promise<AxiosResponse<TResponse<IHomepagePayload>>> {
    return axios.post<TResponse<IHomepagePayload>>(API_ENDPOINTS.HOMEPAGE_SAVE, data)
}

export async function detailHomeData(): Promise<AxiosResponse<TResponseWithQData<IHomepagePayload>>> {
    return axios.get(API_ENDPOINTS.HOMEPAGE_DETAIL)
}


